<template>
  <div class="wrap-avatar">
    <van-image
      v-if="src"
      :src="src"
      fit="cover"
    />
    <van-icon v-else class="base-avatar" name="manager" color="#AEAEAE" :size="size"/>
  </div>
</template>

<script>
export default {
  name: 'avatar',
  props: {
    size: Number,
    src: String
  },
  computed: {
    style() {
      return `width:${this.width}px;height:${this.height}px;`
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap-avatar {
  display: inline-block;
  position: relative;
  top: 0;
  left: 0;
  background: rgba(231, 231, 231, 1);
  border: 2px solid rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 50%;
  .base-avatar {
    @include content-center;
  }
}
</style>

<style lang="scss">
.wrap-avatar {
  overflow: hidden;
  .van-image {
    border-radius: 50%;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
}
</style>

